import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { defaultWMS2020_R01Filter, useWMS2020_R01Store } from "./Store_WMS2020_R01";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { SearchSpacer } from "src/components/common/common";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {}

export const SearchSection_WMS2020_R01 = ({}: Props) => {
    const {
        WMS2020_R01Filter, 
        setWMS2020_R01Filter
    } = useWMS2020_R01Store();

    const {
        wmsCdList,   	
        warehouseCdList,
        brandCdList     
    } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

	const handleItemFoucsId = 'itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: handleItemFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: WMS2020_R01Filter.itemCd || '',
				itemNm: WMS2020_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS2020_R01Filter,
		setEditData: setWMS2020_R01Filter,
		defaultData: defaultWMS2020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS2020_R01_search'
	});

    return (
        <div className="w-full">
            <SearchSectionDoubleForm buttonText="조회" >
                {/* 물류센터 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="물류센터"
                    value={WMS2020_R01Filter.logicCenter}
                    optionList={wmsCdList}
                    onChangeValue={(v) =>
                        setWMS2020_R01Filter({
                            logicCenter: v === "all" ? "" : v,
                        })
                    }
                />

                {/* 창고 선택 */}
                <SearchDropDownForm<WareHouseDto>
                    label="창고명"
                    value={WMS2020_R01Filter.warehouseCd}
                    optionList={warehouseCdList}
                    onChangeValue={(v) =>
                        setWMS2020_R01Filter({
                        warehouseCd: v === "all" ? "" : v,
                        })
                    }
                    />

                {/* 브랜드 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={WMS2020_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={(v) =>
                        setWMS2020_R01Filter({
                            brandCd: v === "all" ? "" : v,
                        })
                    }
                />

                {/* 품목 검색 */}
                <SearchCodeModalForm
                    label="품목코드"
                    value={WMS2020_R01Filter.itemCd}
                    valueLabel={WMS2020_R01Filter.itemNm || ""}
                    handleFoucsId={handleItemFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />
                <SearchSpacer/>
            </SearchSectionDoubleForm>
        </div>
    );
};
